import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { ValidationEnum } from '../models/validation.model';
import { DateHelperService } from '../services/helpers/date-helper.service';

@Injectable({providedIn: 'root'})
export class ValidationService {
	private errMessages = [];

	constructor(private translateService: TranslateService) {
		this.errMessages = [
			{
				name: 'required',
				messages: ''
			}
		];
	}


	getErrMessage(errName, fieldNAme, value?: any) {
		let find = this.messagesList(errName, fieldNAme, value).find(f => f.name === errName);
		// console.log('errName', errName, find);
		return find;
	}

	private messagesList(errName, fieldNAme, value?: any) {
		return [
			{
				name: ValidationEnum.Required,
				message1: fieldNAme,
				message2: this.translateService.instant('users.validation.is-required')
			},

			{
				name: ValidationEnum.Email,
				message1: this.translateService.instant('auth.password-reset.reset-password-invalid-email')
			},

			{
				name: ValidationEnum.MinLength,
				message1: fieldNAme,
				message2: `must be at least ${ value } characters`
			},
			{
				name: ValidationEnum.MaxLength,
				message1: `${ fieldNAme } must be no more that ${ value } characters`
			},
			{
				name: 'file',
				message1: `${ fieldNAme } has unsupported format ${ value }`
			},

			{
				name: ValidationEnum.NotSame,
				message1: this.translateService.instant('users.validation.passwords-not-matched')
			},
			{
				name: ValidationEnum.Pattern,
				message1: this.translateService.instant('users.validation.password-pattern')
			},

			{
				name: ValidationEnum.StartDate,
				message1: 'startDate must be in the future'
			},
			{
				name: ValidationEnum.EndDate,
				message1: 'endDate must be futher than startDate'
			}
		];
	}
}

export function CheckPasswords(group: FormGroup) { // here we have the 'passwords' group
	const password = group.get('password').value;
	const confirmPassword = group.get('confirmPassword').value;

	const isTheSame = password === confirmPassword;
	if (!isTheSame) {
		group.get('confirmPassword').setErrors({ [ValidationEnum.NotSame]: true });
	}
	return isTheSame ? null : { [ValidationEnum.NotSame]: true };
}

export function validateStartDate(group: FormGroup) {
	const startDate = group.get('startDate').value;
	const endDate = group.get('endDate').value;

	let isStartDateInvalid = DateHelperService.isDateLessThan(startDate, new Date());
	let isEndDateInvalid = DateHelperService.isDateLessThan(endDate, startDate);
	// console.log('isStartDateInvalid', isStartDateInvalid);
	// console.log('isEndDateInvalid', isEndDateInvalid);
	if (isStartDateInvalid) {
		group.get('startDate').setErrors({ [ValidationEnum.StartDate]: true });
	}

	if (isEndDateInvalid) {
		group.get('endDate').setErrors({ [ValidationEnum.EndDate]: true });
	}
	return !isStartDateInvalid ? null : { [ValidationEnum.StartDate]: true };
}


